import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'app-supplier-inventory-window',
  templateUrl: './supplier-inventory-window.component.html',
  styleUrls: ['./supplier-inventory-window.component.css']
})
export class SupplierInventoryWindowComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle('/suppliers/create');
  }

}
